export function escapeXML(value) {
  let v = value.toString();
  v = v.replace(/&/g, "&amp;");
  v = v.replace(/</g, "&lt;");
  v = v.replace(/>/g, "&gt;");
  v = v.replace(/"/g, "&quot");
  //v.replace('#13#10', '&#x0D;&#x0A;');
  return v;
}
